module.exports = __webpack_public_path__ + "static/img/showroom6.c5badd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom6.png
// module id = ptic
// module chunks = 2